export const TESTIMONIALS = [
  {
    initial: 'R',
    name: 'Rajesh Kumar',
    loc: 'Mumbai, India · Career Guidance',
    quote:
      "Maharaj Ji's guidance completely changed my career. The remedies he suggested were simple, and within 3 months I got the promotion I had waited years for.",
  },
  {
    initial: 'S',
    name: 'Sarah Jenkins',
    loc: 'London, UK · Home & Vastu',
    quote:
      'I was unsure about an online consultation, but my Kundli reading was so accurate. His Vastu advice brought real peace and harmony to our home.',
  },
  {
    initial: 'A',
    name: 'Amit Patel',
    loc: 'New Jersey, USA · Business',
    quote: 'His honest reading helped me take the right decision during a very tough business phase. Genuine Vedic wisdom with truly practical advice.',
  },
  {
    initial: 'P',
    name: 'Priya Sharma',
    loc: 'Delhi, India · Marriage',
    quote: 'After my Gun Milan and a few simple remedies, the long delays in my marriage finally cleared. I am forever grateful to Maharaj Ji.',
  },
  {
    initial: 'V',
    name: 'Vikram Singh',
    loc: 'Jaipur, India · Health',
    quote: 'My family had faced health worries for a long time. The gemstone and remedies he recommended brought a positive change we can clearly feel.',
  },
  {
    initial: 'M',
    name: 'Meera Nair',
    loc: 'Dubai, UAE · Money & Wealth',
    quote: 'Calm, kind and very accurate. Maharaj Ji explained everything in simple words and the financial guidance helped my savings grow steadily.',
  },
]

export const QUOTE_ICON_PATHS = [
  'M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z',
  'M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z',
]

export const STAR_PATH =
  'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z'
